import { Box, Typography } from "@mui/material";
import React from "react";
import BreadcrumbSection from "../../../components/Breadcrumb/BreadcrumbSection";
import {
  blackColor,
  blueColor04,
  errorTextColor,
} from "../../../configs/styles/muiThemes";
import { stickyHeader } from "../../../utils/styles";
import CatalogActionBtns from "../../../components/Buttons/CatalogActionBtns";
import OndcCategoryPreview from "../Preview/OndcCategoryPreview";
import VariantOndcForm from "../Forms/VariantOndcForm";

function VarianceOndcDetailsTab({
  title,
  titleFrom,
  links,
  pageError,
  onNextClick,
  onBackClick,
  tableHeader,
  productInfo,
  categoryData,
  variantData,
  handleValueChange,
  handleChange,
  onDeleteClick,
  handleCancel,
}) {
  return (
    <Box mt={{ md: 0, xs: 1 }}>
      <Box
        sx={{
          ...stickyHeader,
          display: { md: "block", xs: "none" },
          pb: 1,
        }}
      >
        <BreadcrumbSection links={links} />
        <Typography
          component="h6"
          fontSize={{ xs: 15, md: 17 }}
          color={blackColor}
          fontWeight={{ xs: 600, md: 600 }}
          lineHeight="20px"
          display="inline"
        >
          {titleFrom && <span style={{ color: blueColor04 }}>{titleFrom}</span>}
          {title}
        </Typography>
      </Box>

      <OndcCategoryPreview
        categoryData={categoryData}
        productInfo={productInfo}
      />
      <VariantOndcForm
        tableHeader={tableHeader}
        variantData={variantData}
        handleValueChange={handleValueChange}
        handleChange={handleChange}
        onDeleteClick={onDeleteClick}
      />

      <Box>
        <CatalogActionBtns
          hideSaveBtn
          onNextClick={onNextClick}
          showBackBtn
          onBackClick={onBackClick}
          //   onCancelClick={handleCancel}
        />
        {pageError ? (
          <Typography
            fontSize={12}
            fontWeight={500}
            mt={1}
            textAlign="right"
            color={"red"}
          >
            {pageError}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}

export default VarianceOndcDetailsTab;
